// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"222":"9cb2bc1c","577":"9cb2bc1c","762":"9cb2bc1c","879":"9cb2bc1c","958":"9cb2bc1c"}[chunkId] + ".chunk.css";
};